import moments from "./moments";
import members from "./members";

export const allMoments = moments
export const allMembers = members
export const momentForId = id => moments.find(it => it.id === id)
export const memberForId = id => members.find(it => it.id === id)

export const momentUrl = file => `https://momatu-dev.s3-ap-southeast-2.amazonaws.com/demo/moments/files/${file}`
export const thumbUrl = thumb => `https://momatu-dev.s3-ap-southeast-2.amazonaws.com/demo/moments/thumbs/${thumb}`
export const memberPhotoUrl = photo => `https://momatu-dev.s3-ap-southeast-2.amazonaws.com/demo/members/${photo}`

export const membersForMoment = moment => moment.members && moment.members.map(it => memberForId(it))

export const tagsForMoment = moment => {
    const membersTags = membersForMoment(moment).map(it => ({
        type: 'member',
        value: it.id,
        text: it.firstName,
        photoUrl: memberPhotoUrl(it.photo)
    }))
    const locationTag = {
        type: 'location',
        value: moment.location,
        text: moment.location
    }
    const customTags = moment.tags.map(it => ({
        type: 'custom',
        value: it,
        text: it
    }))
    return [...membersTags, locationTag, ...customTags]
}